import { Card, CardActionArea, CardContent, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useStyles } from './styles';


function ServiceCard({service, id}) {
  const classes = useStyles();
  let history = useHistory();

  function handleChangePage(id) {
    history.push(`${history.location.pathname}/${id}`)
  }

  return(
    <Card 
      className={classes.card} 
      onClick={() => handleChangePage(id)}
    >
      <CardActionArea>
        <CardContent>
          <Typography color="textPrimary" variant="h2">
            {service}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

export default ServiceCard;